import { registerLocaleData } from '@angular/common';
import {
  HTTP_INTERCEPTORS,
  HttpClient,
  provideHttpClient,
  withInterceptorsFromDi,
} from '@angular/common/http';
import localeDa from '@angular/common/locales/da';
import localeDe from '@angular/common/locales/de';
import localeEn from '@angular/common/locales/en';
import localeEs from '@angular/common/locales/es';
import localeFr from '@angular/common/locales/fr';
import localeIt from '@angular/common/locales/it';
import localeNl from '@angular/common/locales/nl';
import localePl from '@angular/common/locales/pl';
import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { RouteReuseStrategy, TitleStrategy } from '@angular/router';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { marked } from 'marked';
import { MarkdownModule, MARKED_OPTIONS, MarkedRenderer, MarkedOptions } from 'ngx-markdown';

import { AcademyModule } from '@academy/academy.module';
import { AlooraTitleStrategy } from '@core/aloora-title/aloora-title-strategy.service';
import { CoreModule } from '@core/core.module';
import { LOCAL_STORAGE_TOKEN, WINDOW_TOKEN } from '@core/domTokens';
import { TokenAuthenticationInterceptor } from '@core/tokenAuthentication.interceptor';
import { MaterialModule } from '@material/material.module';
import { SharedModule } from '@shared/shared.module';
import { NavigationModule } from '@widgets/navigation/navigation.module';

import { AlooraReuseStrategy } from './AlooraRouteReuseStrategy';
import { AppRoutingModule } from './app-routing.module';
import { MobileAppComponent } from './app.component';

export function markedOptionsFactory(): MarkedOptions {
  const renderer = new MarkedRenderer();

  renderer.link = (token) => {
    const href = token.href;
    const title = token.title;

    const titleAttr = title ? ` title="${title}"` : '';
    const text = marked.Parser.parseInline(token.tokens);

    return `<a target="_blank" rel="noopener noreferrer" href="${href}"${titleAttr}>${text}</a>`;
  };

  return {
    renderer,
  };
}

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/main_', '.json');
}

registerLocaleData(localeDa, 'da');
registerLocaleData(localeDe, 'de');
registerLocaleData(localeEn, 'en');
registerLocaleData(localeEs, 'es');
registerLocaleData(localeFr, 'fr');
registerLocaleData(localeIt, 'it');
registerLocaleData(localeNl, 'nl');
registerLocaleData(localePl, 'pl');

@NgModule({
  declarations: [MobileAppComponent],
  bootstrap: [MobileAppComponent],
  imports: [
    BrowserModule,
    CoreModule,
    AppRoutingModule,
    AcademyModule,
    NavigationModule,
    MaterialModule,
    MarkdownModule.forRoot({
      markedOptions: {
        provide: MARKED_OPTIONS,
        useFactory: markedOptionsFactory,
      },
    }),
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    SharedModule,
  ],
  providers: [
    { provide: HTTP_INTERCEPTORS, useClass: TokenAuthenticationInterceptor, multi: true },
    { provide: RouteReuseStrategy, useClass: AlooraReuseStrategy },
    { provide: TitleStrategy, useClass: AlooraTitleStrategy },
    {
      provide: LOCAL_STORAGE_TOKEN,
      useFactory: () => localStorage,
    },
    {
      provide: WINDOW_TOKEN,
      useFactory: () => window,
    },
    provideHttpClient(withInterceptorsFromDi()),
  ],
})
export class AppModule {}
